<template>
    <div class="column_center_center payment_type_popup">
        <div class="column_center_start payment_type_container">
            <text class="title" style="color: #FD5001; margin-bottom: 20px;">選擇付款方式</text>
            <button class="button counter" @click="cashPay" v-if="isCashPaymentEnabled && !isDeliveryType">
                <text id="point_of_sale" class="button-icon"
                    style="font-size: 34px; width: 34px; height: 34px; margin-right: 10px;">point_of_sale</text>
                <text>櫃檯結帳</text>
            </button>
            <button class="button counter" @click="cashPay" v-if="isCashPaymentEnabled && isDeliveryType">
                <text class="button-icon"
                    style="font-size: 34px; width: 34px; height: 34px; margin-right: 10px;">shopping_bag</text>
                <text>{{ deliveryCashPaymentText }}</text>
            </button>
            <!-- TODO 根據需求先隱藏 linePay -->
            <button class="button line_pay mt-2.5" @click="linepay" v-if="linePayPaymentMethod">
                <div class="row_center_center"
                    style="padding: 3px 7px; background-color: #fff; color: #03BF5B; border-radius: 4px; font-weight: 900; margin-right: 10px;">
                    Pay
                </div>
                <text style="color: #fff;">LinePay</text>
            </button>
            <div class="w-full my-5 text-base text-[#666666] row_center_center">或是</div>
            <button @click="close" class="button cancel">返回</button>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        linePayPaymentMethod() {
            return this.$store.getters['payment/linePayPaymentMethod']
        },
        isCashPaymentEnabled() {
            return this.$store.getters['payment/isCashPaymentEnabled']
        },
        isDeliveryType() {
            return ['delivery', 'retailDelivery'].includes(this.geturlParameters.method)
        },
        deliveryCashPaymentText() {
            return this.geturlParameters.method === 'retailDelivery' ? '取貨付款' : '取餐付款'
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        cashPay() {
            this.$emit("cashPay")
            this.$emit("close")
        },
        linepay() {
            this.$emit("linePay")
            this.$emit("close")
        }
    },
}
</script>
<style lang="scss">
.payment_type_popup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.95);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
}

.payment_type_container {
    background-color: #fff;
    padding: 30px 0;
    width: 85%;
    border-radius: 6px;

    .button {
        width: 85%;
        height: 50px;
        border: none;
        font-size: 20px;
        font-weight: 600;
        font-family: PingFang SC;
        color: #000;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.line_pay {
    background-color: #03BF5B;
}

.counter_pay {
    background-color: #FBCB02;
}

.cancel {
    margin: 0 auto;
    background-color: #DDDDDD;
}
</style>
